import type { ReactNode } from 'react';

export const symbol_folder_data: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M560.5-60.56Q540-81.13 540-110q0-21 11-38.5t29-25.5v-243q-18-8-29-25t-11-37.54q0-29.46 20.59-49.96t49.5-20.5q28.91 0 49.41 20.56Q680-508.88 680-480q0 21-11 38t-29 25v135l180-60v-75q-18-8-29-25t-11-37.54q0-29.46 20.59-49.96t49.5-20.5q28.91 0 49.41 20.56Q920-508.88 920-480q0 21-11 38t-29 25v75q0 19.5-11.18 35.25T839-285l-199 66v45q18 8 29 25.5t11 38.04Q680-81 659.41-60.5T609.91-40Q581-40 560.5-60.56ZM140-160v-580 580Zm0 0q-24 0-42-18.5T80-220v-520q0-23 18-41.5t42-18.5h256q12.44 0 23.72 5t19.37 13.09L481-740h369q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H456l-60-60H140v520h310q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Z"
		/>
	</svg>
);
